import React from 'react';
import { Skeleton, SkeletonBlock } from '@one-thd/sui-atomic-components';

/**
 * LoadingSkeleton component for displaying a loading state
 * @returns {JSX.Element} - Skeleton component
 */
const LoadingSkeleton = () => (
  <Skeleton data-testid="skeleton-loader" disablePadding className="sui-h-full" SkeletonContentProps={{ grow: true }}>
    <SkeletonBlock aspect="wide" />
  </Skeleton>
);

export default LoadingSkeleton;
